module.exports = "/_next/static/festival-bfw.css?3Vus2R_";